{
  "version": 1,
  "asset_id": "b865e4c0-e46d-45a4-bb0e-432d089c6f29",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/b865e4c0-e46d-45a4-bb0e-432d089c6f29/td04-eternal-ascent.png",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/b865e4c0-e46d-45a4-bb0e-432d089c6f29/td04-eternal-ascent.png",
  "original_filename": "td04-eternal-ascent.png",
  "size": 989857,
  "content_type": "image/png",
  "created_at": "2026-09-06T13:31:06Z"
}
